import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
// @ts-ignore
import BcDialog from '@/components/Dialog.vue';
let FlowUphold = class FlowUphold extends Vue {
    constructor() {
        super(...arguments);
        this.deviceData = {}; // 设备数据
        this.isOverview = false; // 是否显示设备总览数据
        this.snackbar = new CBcSnackbar();
        this.loading = false;
        this.searchForm = {
            keyword: '',
            displayOption: 0,
        };
        this.productCategory = [];
        this.flowUphold = [];
        // 查看流程明细
        this.dialogDetail = {
            visible: false,
            formData: {},
        };
        this.dialogFlow = {
            visible: false,
            loading: false,
            title: '',
            operType: 'add',
            form: false,
            formData: {},
        };
        this.hintDialog = {
            visible: false,
            loading: false,
            type: 'del',
            text: '',
            title: '',
            formData: {},
        };
        this.activeTab = 0;
        this.menuTabs = [];
        this.devCheckFlowList = [];
        /** 新的UI列表有关 */
        this.dialog = {
            title: '',
            text: '',
            visible: false,
            persistent: false,
            form: false
        };
        this.formDeviceData = {
            devices: [],
            selectDevices: [],
            currentIdList: [],
        };
        this.orderData = {
            hospitalName: '',
            customerName: '',
            oversee: '',
            deviceInfoText: '',
            id: null,
        };
        this.deviceCount = 0;
    }
    showProductFormClick(operType, row) {
        const that = this;
        that.dialogFlow.visible = true;
        that.dialogFlow.operType = operType || 'add';
        that.dialogFlow.formData = Object.assign({ ...row }, {});
        if (that.dialogFlow.operType === 'add') {
            that.dialogFlow.title = row.name;
            that.dialogFlow.formData = {
                category: 0,
            };
        }
        else if (that.dialogFlow.operType === 'edit') {
            that.dialogFlow.title = '编辑流程步骤信息';
        }
    }
    deviceFlowCheck(row, queryType = null) {
    }
    /**
     * 获取流程对应确认记录
     */
    async getFlowCheckRecord() {
        const that = this;
        // const res: any = await that.axios.get('/api/erp/category/product')
        if (that.flowUphold) {
            // 去重后添加到流程线分类中
            const pList = that.flowUphold.map((o) => o.productLine);
            that.productCategory = (pList.filter((value, index, self) => self.indexOf(value) === index) || []).sort((a, b) => {
                const idxa = that.productCategory.indexOf(a);
                const idxb = that.productCategory.indexOf(b);
                if (idxa !== -1 && idxb !== -1)
                    return idxa - idxb;
                if (idxa === -1)
                    return 1;
                if (idxb === -1)
                    return 1;
                return a.localeCompare(b);
            });
        }
    }
    /** 获取确认流程列表 */
    async getDevCheckFlow() {
        const that = this;
        that.loading = true;
        try {
            const queryParams = {
                // hospitalId: that.deviceData.hospitalId,
                receiptId: that.deviceData.receiptId
            };
            const res = await that.axios.get('/api/devCheck/flow', { params: queryParams });
            that.devCheckFlowList = res.data.result || [];
            this.menuTabs = [];
            // 遍历 res.data.result，将数据映射到 tabs
            res.data.result.forEach((item) => {
                const updatedStepInfo = item.stepInfo.map((step) => {
                    // 从 item.recordInfo 中获取 isPass 值
                    const isPassData = item.recordInfo.find((re) => re.flowStepId === step.id);
                    return {
                        ...step,
                        isPass: isPassData && isPassData.isPass || false,
                    };
                });
                this.menuTabs.push({
                    code: item.code || item.id.toString(),
                    id: item.id,
                    label: item.name,
                    content: updatedStepInfo,
                    recordInfo: item.recordInfo,
                });
            });
            that.loading = false;
        }
        catch (e) {
            that.loading = false;
        }
    }
    getImgUrl(item) {
        if (item.name === '收货核对') {
            return 'flow-confirm.png';
        }
        else if (item.name === '装机调试') {
            return 'flow-test.png';
        }
        else if (item.name === '临床使用') {
            return 'flow-use.png';
        }
        else if (item.name === '设备验收') {
            return 'flow-check.png';
        }
        else {
            return 'flow-confirm.png';
        }
    }
    backTo() {
        const that = this;
        that.$router.push({
            name: 'CheckFlow',
            params: {
                deviceId: that.deviceData.deviceId,
                deviceNo: that.deviceData.deviceNo,
            }
        });
    }
    async mounted() {
        const that = this;
        const deviceInfo = that.$route.params || {};
        // 手动新增的订单维护记录，则没有实际的订单记录，outboundOrderId 可能为空
        if (!deviceInfo || !deviceInfo.customerName || !deviceInfo.orderNumber) {
            that.backTo();
        }
        // console.log(' ----: ', JSON.stringify(deviceInfo))
        this.deviceData = deviceInfo;
        this.deviceCount = (deviceInfo.products || []).length;
        this.orderData.hospitalName = deviceInfo.hospitalName || deviceInfo.customerName || '';
        this.orderData.customerName = deviceInfo.customerName || '';
        this.orderData.oversee = '开发中';
        this.orderData.id = deviceInfo.id;
        switch (true) {
            case (deviceInfo.outboundOrderId && /0/i.test(deviceInfo.orderStatus)):
                {
                    this.deviceData.orderStatusText = '未提交';
                }
                break;
            case (deviceInfo.outboundOrderId && /1/i.test(deviceInfo.orderStatus)):
                {
                    this.deviceData.orderStatusText = '补货中';
                }
                break;
            case (deviceInfo.outboundOrderId && /2/i.test(deviceInfo.orderStatus)):
                {
                    this.deviceData.orderStatusText = '仓库审核';
                }
                break;
            case (deviceInfo.outboundOrderId && /3/i.test(deviceInfo.orderStatus)):
                {
                    this.deviceData.orderStatusText = '销售审核';
                }
                break;
            case (deviceInfo.outboundOrderId && /4/i.test(deviceInfo.orderStatus)):
                {
                    this.deviceData.orderStatusText = '财务审核';
                }
                break;
            case (deviceInfo.outboundOrderId && /5/i.test(deviceInfo.orderStatus)):
                {
                    this.deviceData.orderStatusText = '待发货';
                }
                break;
            case (deviceInfo.outboundOrderId && /6/i.test(deviceInfo.orderStatus)):
                {
                    this.deviceData.orderStatusText = '配送中';
                }
                break;
            case (deviceInfo.outboundOrderId && /7/i.test(deviceInfo.orderStatus)):
                {
                    this.deviceData.orderStatusText = '已完成';
                }
                break;
            case (deviceInfo.outboundOrderId && /8/i.test(deviceInfo.orderStatus)):
                {
                    this.deviceData.orderStatusText = '作废';
                }
                break;
            default:
                {
                    this.deviceData.orderStatusText = '未找到订单';
                }
                break;
        }
        // console.log('device list info: ', JSON.stringify(deviceInfo), JSON.stringify(devInfoList))
        // console.log('deviceInfo of params: ', JSON.stringify(deviceInfo));
        this.isOverview = !!(deviceInfo && deviceInfo.queryType === 'overview');
        this.activeTab = deviceInfo && deviceInfo.activeTab ? Number(deviceInfo.activeTab) : 0;
        await this.getDevCheckFlow();
        if (deviceInfo.products && deviceInfo.products.length) {
            this.formDeviceData.currentIdList = deviceInfo.products.map((item) => item && item.productInfoId).filter((f) => f);
        }
        await this.reloadInfo();
    }
    /** 跳转详情页面 */
    btnDetailsPage(row, recordInfo) {
        const that = this;
        row.titleName = this.menuTabs.find((item) => item.code === row.flowId).label || '';
        const recordData = recordInfo.find((item) => item.flowStepId === row.id);
        this.deviceData.isPass = recordData?.isPass || 1;
        if (!row.name || !row.id) {
            that.snackbar.error('获取流程步骤名称为空，请联系管理员维护！');
            return;
        }
        this.$router.push({
            name: 'FlowStepUphold',
            params: {
                deviceInfo: JSON.stringify(this.deviceData || {}),
                flowCheckInfo: JSON.stringify(row || {}),
                activeTab: JSON.stringify(this.activeTab || 0),
                queryType: '',
            }
        });
    }
    stopLineClick(selectData) {
        if (selectData.isConfirm && /null|0|false/i.test(selectData.isPass)) {
            this.snackbar.info('注意上传图片信息');
            selectData.isPass = false;
        }
    }
    /** 更改维护记录状态 */
    async checkboxClick(item, selectData) {
        const that = this;
        // 判断当前数值是否存在，上传记录
        const selectTb = this.menuTabs.find((item) => item.code == selectData.flowId);
        const selectFlow = selectTb.recordInfo.find((item) => item.flowStepId === selectData.id);
        if (selectData.isConfirm && (!selectFlow || !selectFlow?.imageUrl || !selectFlow?.imageUrl?.length)) {
            that.snackbar.warn('请先上传图片信息');
            selectData.isPass = false;
            return;
        }
        try {
            const params = {
                receiptId: this.deviceData.receiptId,
                erpOrderNo: this.deviceData.orderNumber,
                hospitalId: this.deviceData.hospitalId,
                isPass: selectData.isPass,
                flowId: selectTb.code,
                flowStepId: selectFlow && selectFlow.flowStepId || selectData.id
            };
            if (selectFlow) {
                // 存在发送更新请求
                // await this.updateFlowStepForm(params);
                await that.axios.put('/api/devCheck/flowRecord/' + selectFlow.id, params).catch((err) => {
                    that.snackbar.error('保存失败');
                    this.getDevCheckFlow();
                });
            }
            else {
                // 不存在发送添加请求
                // await this.saveFlowStepForm(params);
                that.axios.post('/api/devCheck/flowRecord', params).then((res) => {
                    if (!res.data.result || !res.data.result.id) {
                        that.snackbar.error('保存失败');
                        this.getDevCheckFlow();
                    }
                }).catch((err) => {
                    that.snackbar.error('保存失败');
                    this.getDevCheckFlow();
                });
            }
        }
        catch (error) {
            console.error('售后模块-更改维护记录状态失败');
            this.snackbar.error('操作失败');
        }
    }
    /** 保存维护记录 */
    async saveFlowStepForm(selectTb) {
        const that = this;
        // that.loading = true;
        try {
            const requestInfo = {
                receiptId: selectTb.receiptId,
                flowId: selectTb.flowId,
                flowStepId: selectTb.flowStepId,
                isPass: selectTb.isPass,
            };
            that.axios.post('/api/devCheck/flowRecord', requestInfo).then((res) => {
                if (res.data.result && res.data.result.id) {
                    // this.goNext()
                }
                else {
                    that.snackbar.error('保存失败', res.data.result);
                }
            });
        }
        catch (error) {
            console.log('保存失败', error);
            that.snackbar.error('保存失败', error);
        }
    }
    /** 更新维护记录 */
    async updateFlowStepForm(selectTb) {
        const that = this;
        try {
            const requestInfo = {
                receiptId: that.deviceData.receiptId,
                flowId: selectTb.flowId,
                flowStepId: selectTb.id,
                isPass: selectTb.isPass,
            };
            await that.axios.put('/api/devCheck/flowRecord/' + selectTb.id, requestInfo);
        }
        catch (error) {
            console.error('updateFlowStepForm error', error);
            that.snackbar.error('更新失败');
        }
    }
    removeSelectedDevice(item) {
        const that = this;
        /* 注意这儿，产生移除和新增时selectDevices对应的数据类型不一致,一会儿是[number],一会是[Object] */
        // console.log('remove data: ', JSON.stringify(item.deviceId))
        const index = that.formDeviceData.devices.findIndex((it) => it.id == item.id);
        if (index !== -1) {
            const it = that.formDeviceData.devices[index];
            const sIndex = that.formDeviceData.selectDevices.findIndex((sIt) => it == sIt.deviceId || it.deviceId == sIt.deviceId);
            if (sIndex != -1) {
                that.formDeviceData.selectDevices.splice(sIndex, 1);
            }
            that.formDeviceData.devices.splice(index, 1);
        }
        // console.log(' leave over: ', JSON.stringify(that.formDeviceData.selectDevices))
    }
    deviceFilter(item, queryText) {
        return (new RegExp(queryText.toUpperCase(), 'i').test(item['deviceNo'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['name'].toUpperCase()));
    }
    closeDialog() {
        const that = this;
        that.dialog.visible = false;
    }
    async reloadInfo() {
        const that = this;
        const params = {
            withProducts: true,
            keyword: '医院',
        };
        // console.log('current: ', JSON.stringify(this.formDeviceData.currentIdList))
        const res = await that.axios.get('/api/device', { params });
        const devInfoList = res?.data?.result || [];
        this.formDeviceData.devices = devInfoList;
        this.formDeviceData.devices.forEach((item) => {
            if (this.formDeviceData.currentIdList.includes(item.id)) {
                this.formDeviceData.selectDevices.push(item.deviceId);
            }
        });
        this.formDeviceData.selectDevices.splice(0, this.formDeviceData.selectDevices.length);
        let showItem = null;
        if (this.formDeviceData.currentIdList.length) {
            this.formDeviceData.devices.forEach((item) => {
                if (this.formDeviceData.currentIdList.includes(item.id)) {
                    if (!showItem) {
                        showItem = item;
                    }
                    this.formDeviceData.selectDevices.push(item.deviceId);
                }
            });
        }
        this.deviceCount = this.formDeviceData.currentIdList.length;
        this.orderData.deviceInfoText = '';
        if (showItem) {
            this.orderData.deviceInfoText = showItem.type + '(' + showItem.mode + ')等' + this.deviceCount + '台';
        }
        // console.log('default selecte: ', JSON.stringify(this.formDeviceData.selectDevices))
    }
    editOrderClicked() {
        const that = this;
        that.formDeviceData.selectDevices = this.formDeviceData.devices.filter((item) => {
            if (that.formDeviceData.currentIdList.includes(item.id)) {
                return true;
            }
        });
        that.dialog.visible = true;
        that.dialog.form = true;
    }
    deleteOrderClicked() {
        const that = this;
        that.hintDialog.title = '删除项目';
        that.hintDialog.text = '确定要删除该项目吗？';
        that.hintDialog.visible = true;
        that.hintDialog.type = 'del';
        that.hintDialog.formData = JSON.parse(JSON.stringify(this.deviceData));
    }
    async hintDialogConfirm() {
        const that = this;
        if (that.hintDialog.type === 'del') {
            that.hintDialog.loading = true;
            console.log('delete', that.hintDialog.formData);
            // 删除事件
            await that.axios
                .delete('/api/devCheck/receiptRecord/remove/' + that.hintDialog.formData.receiptId)
                .then((res) => {
                that.hintDialog.loading = false;
                // 提示成功刷新页面
                that.hintDialog.visible = false;
                that.snackbar.success('删除项目成功');
                this.backTo();
            })
                .catch((e) => {
                that.hintDialog.loading = false;
                const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
                that.snackbar.error(`删除项目失败${resMeg}`);
                console.log('删除项目失败', e);
            });
        }
    }
    async saveChanges() {
        const that = this;
        const { id } = this.orderData;
        if (!id) {
            this.snackbar.error('设备记录存在异常，放弃数据更新');
        }
        // const selectedList = [...this.formDeviceData.selectDevices];
        this.deviceData.hospatalName = this.orderData.hospitalName;
        this.deviceData.customerName = this.orderData.customerName;
        this.closeDialog();
        const selectedList = this.formDeviceData.devices.filter((device) => {
            if (!device)
                return false;
            if (this.formDeviceData.selectDevices.includes(device?.deviceId)) {
                return true;
            }
            const item = this.formDeviceData.selectDevices.find((it) => it == device.deviceId || it.deviceId == device.deviceId);
            if (item) {
                return true;
            }
        });
        // return;
        const productsList = selectedList.map((item) => ({
            productInfoId: item.id,
            productName: item.name,
            model: item.mode,
            specifications: item.specifications,
            quantity: 1,
            quantityUnit: '台',
            remark: '',
            receiptId: null,
            deviceNo: item.deviceNo
        }));
        const params = Object.assign(this.orderData, { detailsList: productsList });
        await that.axios.put(`/api/devCheck/receiptRecord/receipt/${id}`, params)
            .then(() => { })
            .catch((err) => {
            this.snackbar.error('操作失败:' + err.info);
        });
        this.formDeviceData.currentIdList = selectedList.map((item) => item.deviceId);
        await this.reloadInfo();
    }
};
FlowUphold = __decorate([
    Component({
        name: 'FlowUphold',
        components: {
            BcSnackbar,
            BcDialog,
        },
    })
], FlowUphold);
export default FlowUphold;
